<template>
  <print v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @selectField="selectField" />

    <!-- 점검정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 점검정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>관리주체</div>
          <ml-input readonly v-model="form.관리주체" />
        </div>
        <div>
          <div>준공일</div>
          <ml-input readonly v-model="form.준공일" />
        </div>
        <div>
          <div>점검일</div>
          <date-selector :readonly="board.readonly" v-model="form.점검일" />
        </div>
      </div>
    </div>

    <!-- 점검분야 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 점검분야</h5>
      <div class="grid grid-cols-1 md:grid-cols-4 gap-x-6 gap-y-4 mt-4">
        <div v-for="(_title, _title_i) in getTitles" :key="`checkbox_${_title}`" class="col-span-1 flex items-center">
          <div v-if="isPrint || board.readonly" class="flex items-center">
            <div v-if="form.inspectChecked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">
              {{ _title }}
            </span>
          </div>
          <div v-else>
            <span class="flex">
              <vs-checkbox color="secondary" :disabled="_title_i === 0" v-model="form.inspectChecked" :vs-value="_title">{{ _title }}</vs-checkbox>
            </span>
          </div>
        </div>
      </div>
    </div>

    <TableInspectMerge
      v-for="item in form.inspectList"
      :key="`inspect_${item.title}`"
      v-show="form.inspectChecked.includes(item.title)"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="item.title"
      :tableHeaderTitle="item.tableHeaderTitle || '점검내용'"
      :tableHeaderCheck="item.tableHeaderCheck"
      :tableHeaderNote="item.tableHeaderNote"
      :footer="item.footer"
      v-model="item.list"
      class="mt-5"
    >
      <template #customContent="{ trData, id, input }">
        <div v-if="trData && trData.contentType === 1">
          <p>· 질병이 있는 종업원에 의한</p>
          <p>　 - 영업자 및 집단급식소 설치･운영자의 건강진단 실시(위탁급식소의 경우 제외)</p>
          <p class="flex" style="align-items: center;">　 - 종업원의 건강진단 실시여부
            <ml-input :readonly="board.readonly" class="px-2" v-model="trData.input1" placeholder="입력" style="width: 60px;"/> /
            <ml-input :readonly="board.readonly" class="px-2" v-model="trData.input2" placeholder="입력" style="width: 60px;"/> 명
          </p>
          <p class="flex" style="align-items: center;">　 - 건강진단을 받지 아니한 자를 영업에 종사시키는 지 여부
            <ml-input :readonly="board.readonly" class="px-2" v-model="trData.input3" placeholder="입력" style="width: 60px;"/> /
            <ml-input :readonly="board.readonly" class="px-2" v-model="trData.input4" placeholder="입력" style="width: 60px;"/> 명
          </p>
          <p>　 - 건강진단결과 타인에게 위해를 끼칠 우려가 있는 질병이 있다고 인정된 자를 영업에 종사시키는지 여부</p>
        </div>
      </template>
    </TableInspectMerge>

    <!-- 확인자 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import Print from "./Print";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    Print,
    DateSelector,
    SignField,
    FileUploadModule,
    TableInspectMerge,
    FieldSelectModule,
    PhotoUploadGridModule,
    DisasterClassSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        관리주체: "",
        준공일: "",
        점검일: "",

        inspectionTitle: "",
        inspectChecked: ["공동분야"],
        inspectList: inspectData,

        sign1: { name: "", sign: "" },
        sign2: { name: "", sign: "" },
        sign3: { name: "", sign: "" },
        sign4: { name: "", sign: "" },
      },
    };
  },
  computed: {
    getTitles() {
      return this.form.inspectList.map((item) => item.title);
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inspectionTitle = value.inspectChecked.join(", ");
        this.$emit("input", value);
      },
    },
  },
  methods: {
    selectField(data) {
      const meta = JSON.parse(data.meta);

      this.form.관리주체 = meta.management_entity;
      this.form.준공일 = data.be_completed_at;
    },
  },
};
</script>
